module.exports = __webpack_public_path__ + "static/media/eighty_percent.f0c72d9b.png";